<template>
    <div role="dialog" aria-modal="true"
         aria-label="题库申请" v-show="visible" class="dialog-modal">
        <div class="dialog" v-show="visible">
            <i class="el-icon-circle-close close-icon" @click.stop="close"/>
            <template v-if="applyStatus === 'applying'">
                <h3 class="greetings">您好</h3>
                <div class="tips">请您填写准确的信息，即可获得7天免费使用</div>
                <el-form :model="form" size="small" ref="form" :inline="false" label-width="100px">
                    <el-form-item label="姓名" prop="Name" :rules="getRules">
                        <el-input v-model="form.Name" placeholder="请输入姓名"/>
                    </el-form-item>
                    <el-form-item label="手机号" prop="Telephone" :rules="phoneRules">
                        <el-input v-model="form.Telephone" placeholder="请输入手机号"/>
                    </el-form-item>
                    <el-form-item label="验证码" prop="sendcode" :rules="getRules">
                        <el-row type="flex" justify="space-between" align="center">
                            <el-input v-model="form.sendcode" placeholder="请输入验证码"/>
                            <button class="btn-reset code-btn"
                                    tabindex="6"
                                    :disabled="codeDisabled"
                                    @keyup.enter.stop="handleSendCode"
                                    @click.stop="handleSendCode">{{
                                    timeCountDown ? timeCountDown + "秒" : "发送验证码"
                                }}
                            </button>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="密码" prop="PassWord" :rules="passwordRules">
                        <el-input v-model="form.PassWord" placeholder="请输入密码" type="password" show-password/>
                    </el-form-item>
                    <el-form-item label="机构" prop="GroupName" :rules="getRules">
                        <el-input v-model="form.GroupName" placeholder="请输入机构"/>
                    </el-form-item>
                    <el-form-item label="行业" prop="Industry" :rules="getRules">
                        <el-input v-model="form.Industry" placeholder="请输入行业名称"/>
                    </el-form-item>
                    <el-form-item label="业务需求" prop="Business" :rules="getRules">
                        <el-checkbox-group v-model="form.Business">
                            <el-checkbox border label="在线考试">在线考试</el-checkbox>
                            <el-checkbox label="院内培训" border>院内培训</el-checkbox>
                            <el-checkbox label="试题加工" border>试题加工</el-checkbox>
                            <el-checkbox label="问卷调查" border>问卷调查</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="其他需求" prop="Remarks">
                        <el-input v-model="form.Remarks"
                                  placeholder="请输入其他需求"
                                  resize="none"
                                  :autosize="{ minRows: 4, maxRows: 6 }"
                                  type="textarea"/>
                    </el-form-item>
                </el-form>
                <button class="btn-reset submit-btn"
                        tabindex="20"
                        @keyup.enter.stop="handleSubmit"
                        @click.stop="handleSubmit">立即提交
                </button>
            </template>
            <template v-else>
                <el-result icon="success" title="您好"
                           subTitle="您已提交成功，无需重复提交客服会尽快与您联系，请耐心等候哟～">
                    <template slot="extra">
                        <button class="btn-reset submit-btn"
                                tabindex="22"
                                @click.stop="close">返回首页
                        </button>
                        <div class="phone">
                            <i class="el-icon-phone-outline phone-icon"/>
                            商务电话：023-63410392
                        </div>
                    </template>
                </el-result>
            </template>
        </div>
    </div>
</template>

<script>
import { sendTrialCode, submitForm } from "@/api/home/organization"
import { sm2Encrypt } from "@/utils/sm2"
const timeCountDown = "EXAM_TIME_COUNT_DOWN"
const startTime = "EXAM_START_TIME"
export default {
    name: "Dialog",
    data() {
        return {
            visible: false,
            form: { Business: [] },
            timeCountDown: parseInt(window.localStorage.getItem(timeCountDown)) || 0,
            applyStatus: "applying", // 申请状态
            codeDisabled: parseInt(window.localStorage.getItem(timeCountDown)) > 0
        }
    },
    computed: {
        getRules() {
            return [
                {
                    required: true,
                    message: "请输入",
                    trigger: "blur"
                }
            ]
        },
        phoneRules({ getRules }) {
            return getRules.concat([{
                pattern: /^1[3-9]\d{9}$/,
                message: "请输入正确的手机号",
                trigger: "blur"
            }])
        },
        passwordRules({ getRules }) {
            return getRules.concat([{
                pattern: /^[0-9A-Za-z]{6,12}$/,
                message: "请输入字母或数字长度6-12位密码",
                trigger: "blur"
            }])
        }
    },
    methods: {
        open() {
            this.visible = true
        },
        close() {
            this.$refs.form && this.$refs.form.clearValidate()
            this.visible = false
        },
        // 发送验证码
        handleSendCode() {
            this.$refs.form.validateField(["Telephone"], (isError) => {
                if (isError) return
                this.codeDisabled = true
                sendTrialCode(this.form.Telephone).then(res => {
                    this.timeCountDown = 60
                    this.handleCountDown()
                    this.$message.success("发送成功")
                }).catch(err => {
                    this.$message.error(err?.message || "发送失败")
                    this.timeCountDown = 0
                    window.localStorage.setItem(timeCountDown, "0")
                    this.codeDisabled = false
                    clearInterval(this.timer)
                })
            })
        },
        // 处理提交
        handleSubmit() {
            this.$refs.form.validate((isPass) => {
                if (isPass) {
                    const {
                        Business,
                        PassWord,
                        ...otherProps
                    } = this.form
                    submitForm(Object.assign(otherProps, {
                        Business: Business.join(),
                        Type: 0,
                        PassWord: sm2Encrypt(PassWord)
                    })).then(res => {
                        this.$message.success("申请成功")
                        this.applyStatus = "success"
                    })
                }
            })
        },
        // 处理倒计时
        handleCountDown() {
            this.timer = setInterval(() => {
                if (this.timeCountDown > 0) {
                    this.timeCountDown--
                    if (this.codeDisabled !== true) {
                        this.codeDisabled = true
                    }
                } else {
                    clearInterval(this.timer)
                    this.codeDisabled = false
                }
                window.localStorage.setItem(timeCountDown, String(this.timeCountDown))
            }, 1000)
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
}
</script>

<style scoped lang="less">
.dialog-modal {
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}

.dialog {
    position: absolute;
    left: 30%;
    top: 15%;
    right: 30%;
    box-sizing: border-box;
    padding: 1% 4% 3%;
    background-color: #fff;
    border-radius: 40px 12px 40px 12px;

    .close-icon {
        position: absolute;
        right: -50px;
        top: 0;
        color: #BAC0CA;
        font-size: 40px;
        cursor: pointer;
    }
}

.greetings {
    font-size: 24px;
    color: #333;
    text-align: center;
}

.tips {
    text-align: center;
    color: #72777F;
    font-size: 14px;
    margin-bottom: 30px;
}

.code-btn {
    background: linear-gradient(270deg, #256CF4 0%, #4CA5FA 100%);
    border-radius: 6px;
    color: #fff;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-left: 10px;

    &:disabled {
        opacity: .5;
        cursor: not-allowed;
    }
}

.submit-btn {
    display: block;
    width: 50%;
    padding-top: 16px;
    padding-bottom: 16px;
    background: linear-gradient(270deg, #256CF4 0%, #4CA5FA 100%);
    border-radius: 8px;
    color: #fff;
    margin: 30px auto 0;
}
.phone {
    margin-top: 30px;
    font-size: 16px;
    .phone-icon {
        color: #4592ff;
        font-size: 24px;
        vertical-align: middle;
    }
}

</style>
